import { createFileRoute } from "@tanstack/react-router";
import PeoJoinPage from "@/components/peo/PeoJoinPage";

export const Route = createFileRoute("/prestige")({
  head: () => {
    const title = "Your homeownership benefit — Home Approach";
    const description = "Join Home Approach free through your employer with your company code: down payment help, readiness and a guide to closing.";
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { name: "robots", content: "noindex, nofollow" },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "website" },
        { name: "twitter:card", content: "summary" },
      ],
    };
  },
  component: () => <PeoJoinPage peoSlug="prestige" />,
});
